/** @format */
import process from "process";
import { apiRequest } from "../Component/Utils/ApiHundler";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function getInstance(token, modelId = null) {
  const apiUrl = `${API_BASE_URL}/process/list/full`;

  // Créer un objet body avec ModelId uniquement s'il est fourni
  const body = modelId ? { ModelId: modelId } : {};

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(body),
  });

  return data.message.list;
}